import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PrescriptionOrder} from 'src/app/interfaces/common/prescription-order';
import { Order } from 'src/app/interfaces/common/order';
import { FilterData } from 'src/app/interfaces/core/filter-data';
import { RequestMedicine } from 'src/app/interfaces/common/request-medicine';


const API_ORDER = environment.apiBaseLink + '/api/request-medicine/';
const API_REQUEST_MEDICINE = environment.apiBaseLink + '/api/request-medicine/';
const API_ORDER_TEMP = environment.apiBaseLink + '/api/order-temporary/';

@Injectable({
  providedIn: 'root'
})
export class RequestMedicineService {

  constructor(
    private httpClient: HttpClient
  ) {
  }


  /**
   * ORDER
   */
  placeOrder(data: PrescriptionOrder) {
    return this.httpClient.post<{ _id: string; orderId: any; message: string; success: boolean }>(API_ORDER + 'add-prescription-order-by-user', data);
  }

  confirmRequestMedicine(data: any) {
    return this.httpClient.post<{ _id: string; orderId: any; message: string; success: boolean }>(API_ORDER + 'confirm-prescription-order', data);
  }



  updateOrderSessionKey(tranId: string, sessionkey: string) {
    return this.httpClient.post<{ message: string }>(API_ORDER_TEMP + 'update-session-key/' + tranId + '/' + sessionkey, {});
  }



  getAllRequestMedicinesByUser(filter?:FilterData, searchQuery?:string) {
      let params = new HttpParams();
       if(searchQuery){
          params = params.append('q',searchQuery);
       }
       return this.httpClient.post<{data:RequestMedicine[],success:boolean,message:string}>(API_ORDER + 'get-all-request-medicines-by-user',filter,{params})
  }

  deletePrescriptionByUser(id:string){
      return this.httpClient.delete(API_ORDER+'delete/'+id);
  }

    /**
   * ADD REQUEST MEDICINE
   */
    addRequestMedicine(data: RequestMedicine) {
      return this.httpClient.post<{ _id: string; orderId: any; message: string; success: boolean }>(API_REQUEST_MEDICINE+ 'add-request-medicine-by-user', data);
    }

}
